import { render, staticRenderFns } from "./SettingsBotsListTitle.vue?vue&type=template&id=08789454&"
import script from "./SettingsBotsListTitle.vue?vue&type=script&lang=js&"
export * from "./SettingsBotsListTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports